import { render } from "./AddArticle.vue?vue&type=template&id=0ae1df94&scoped=true"
import script from "./AddArticle.vue?vue&type=script&lang=js"
export * from "./AddArticle.vue?vue&type=script&lang=js"

import "./AddArticle.vue?vue&type=style&index=0&id=0ae1df94&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae1df94"]])

export default __exports__